import type { UserIsBot } from "../../types/experiment";
import { Switch } from "../ui/switch";
import { Label } from "../ui/label";

interface BotFilterProps {
  value: UserIsBot;
  onChange: (value: UserIsBot) => void;
}

export function BotFilter({ value, onChange }: BotFilterProps) {
  return (
    <div className="flex items-center gap-2">
      <Switch
        checked={value.is_bot}
        onCheckedChange={(checked) => onChange({ is_bot: checked })}
      />
      <Label className="text-xs">{value.is_bot ? "Bot" : "User"}</Label>
    </div>
  );
}
